<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Team Members</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a [routerLink]="getDashboardRoute()"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Team Members</li>
        </ol>
      </nav>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between">
      <h3>Team Members</h3>
      <div class="d-flex align-items-center">
        <div class="me-3">
          <select
            class="form-select form-select-sm col-md-1"
            id="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <!-- <option selected disabled>Show Entries Per Page</option> -->
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
          </select>
        </div>
        <div class="dropdown me-3">
          <input
            type="text"
            [(ngModel)]="search"
            (ngModelChange)="onSearchChange($event)"
            class="form-control"
            placeholder="Search Team Member"
          />
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="custom-datatable-filter table-responsive">
          <ng-container *ngIf="teamMemberList.length > 0; else noRecords">
            <table class="table datatable" *ngIf="teamMemberList.length > 0">
              <thead class="thead-light">
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <!-- <th>Designation</th> -->
                  <!-- <th>Joining Date</th> -->
                  <!-- <th class="text-end" *appHasPermission="{ employees: ['view'] }">Action</th> -->
                  <th>Manager</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let member of teamMemberList">
                  <td>
                    <div class="d-flex align-items-center">
                      <a [routerLink]="['/hrm/employee', member.id]">
                        <!-- <img
                          *ngIf="member.picture; else initials"
                          [src]="apiEndpoint + '/uploads/' + member.picture"
                          class="rounded-circle border border-2"
                          style="width: 40px; height: 40px"
                          alt="img"
                        /> -->

                        <img
                          *ngIf="!member.showInitials; else initials"
                          [src]="apiEndpoint + '/uploads/' + member.picture"
                          (error)="member.showInitials = true"
                          class="rounded-circle border border-2"
                          style="
                            width: 40px;
                            height: 40px;
                            object-fit: cover;
                            object-position: center;
                            overflow: hidden;
                            aspect-ratio: 1 / 1;
                          "
                          alt="img"
                        />

                        <ng-template #initials>
                          <div
                            class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                            style="width: 40px; height: 40px"
                          >
                            {{ member.firstName[0] }}{{ member.lastName[0] }}
                          </div>
                        </ng-template>
                      </a>
                      <span>
                        <div class="ms-2">
                          <a [routerLink]="['/hrm/employee', member.id]">
                            {{ member.firstName }} {{ member.lastName }}
                          </a>
                        </div>
                        <div class="ms-2 text-muted small">
                          {{ member.designation.designationName }}
                        </div>
                      </span>
                    </div>
                  </td>
                  <!-- </div>{{ member.firstName }} {{ member.lastName }}</td> -->
                  <td>{{ member.email }}</td>
                  <td>{{ member.mobile }}</td>
                  <td>
                    <span class="fs-12">
                      {{ member.manager?.firstName || 'N/A' }}
                      {{ member.manager?.lastName || '' }}
                    </span>
                  </td>
                  <!-- <td>{{ member.designation.designationName }}</td> -->
                  <!-- <td>{{ member.joiningDate | date: 'mediumDate' }}</td> -->
                  <!-- <td class="text-end" *appHasPermission="{ employees: ['view'] }">
                    <div class="action-icon d-inline-flex">
                      <button
                        type="button"
                        class="btn btn-icon-style p-1 m-1"
                        aria-label="View item"
                        data-bs-toggle="modal"
                        data-bs-target="#notificationDetailsModal"
                        title="View"
                      >
                        <i
                          class="ti ti-eye"
                          [routerLink]="['/', eps.hrm.base, eps.hrm.employee, member.id]"
                        ></i>
                      </button>
                    </div>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </ng-container>

          <ng-template #noRecords>
            <div class="text-center">Record not available</div>
          </ng-template>
        </div>

        <!-- pagination -->
        <ng-container *ngIf="teamMemberList.length > 0">
          <div
            class="d-flex align-items-center justify-content-between ms-2"
            *ngIf="teamMemberList.length > 0"
          >
            <div>
              <!-- Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
              {{ totalCount }} entries -->
              Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ currentPage * pageLimit }} of
              {{ totalCount }} entries
            </div>
            <div class="has-text-centered mt-3">
              <app-pagination
                [currentPage]="currentPage"
                [pageSize]="pageLimit"
                [totalRows]="totalCount"
                (pageChange)="goTopPage($event)"
              ></app-pagination>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- <div class="card-body">
    <div *ngIf="teamMembers.length > 0; else noTeamMembers">
      <div class="d-flex align-items-start mb-4" *ngFor="let member of teamMembers">
        <ng-container *ngIf="member.picture; else initials">
          <img
            [src]="apiEndpoint + '/uploads/' + member.picture"
            class="rounded-circle border border-2"
            alt="img"
            style="width: 40px; height: 40px; object-fit: cover"
          />
        </ng-container>
        <ng-template #initials>
          <span
            class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
            style="width: 40px; height: 40px"
            >{{ getInitials(member.firstName, member.lastName) }}
          </span>
        </ng-template>
        <div class="ms-2">
          <h6>{{ member.firstName }} {{ member.lastName }}</h6>
          <p>{{ member.designation?.designationName || 'N/A' }}</p>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noTeamMembers>
    <p>No team members found.</p>
  </ng-template> -->
